<template>
  <div id="adminUser">
    <vue-headful :title="$store.state.option['conta_pessoal_user-titulo-' + lang]" :lang="lang" />

    <div v-if="form.role == 'driver'">
      <!--<div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-clientID-' + lang]}}</label>
        <input disabled v-model="form.clientID" type="text" class="form-control">
      </div>-->
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-name-' + lang]}}</label>
        <input v-model="form.driver_Name" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-email-' + lang]}}</label>
        <input v-model="form.email" type="text" disabled class="form-control">
      </div>
      <div class="form-group">
        <label for="email_Notification">{{$store.state.option['conta_pessoal_user-email_Notification-' + lang]}}</label>
        <input id="email_Notification" v-model="form.email_Notification" type="checkbox">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Address-' + lang]}}</label>
        <textarea v-model="form.address" class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-PostalCode-' + lang]}}</label>
        <input v-model="form.postal_Code" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-City-' + lang]}}</label>
        <input v-model="form.city" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Country-' + lang]}}</label>
        <select id="country" class="form-control" v-model="form.country" style="height:50px;">
          <option value="">{{$store.state.option['country-' + lang]}}</option>
          <option :value="'' +dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
        </select>
      </div>
      <!--<div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-CreatedAt-' + lang]}}</label>
        <input disabled v-model="form.created_at" type="text" class="form-control">
      </div>-->
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-DateBirth-' + lang]}}</label>
        <!--<input v-model="form.date_of_Birth" type="text" class="form-control">-->
        <date-picker v-model="form.date_of_Birth" :clearable="false" :editable="false" type="date"></date-picker>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-LicenseDate-' + lang]}}</label>
        <!--<input v-model="form.license_Date" type="text" class="form-control">-->
        <date-picker v-model="form.license_Date" :clearable="false" :editable="false" type="date"></date-picker>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-LicenseNumber-' + lang]}}</label>
        <input v-model="form.license_Number" type="text" class="form-control">
      </div>

      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-license_Place-' + lang]}}</label>
        <input v-model="form.license_Place" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-license_Country-' + lang]}}</label>
        <select id="license_Country" class="form-control" required="required" v-model="form.license_Country" style="height:50px;">
          <option value="">{{$store.state.option['license_Country-' + lang]}}</option>
          <option :value="'' +dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
        </select>
      </div>

      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-document_Type-' + lang]}}</label>
        <select id="document_Type" class="form-control" required="required" v-model="form.document_Type" style="height:50px;">
          <option value="">{{$store.state.option['document_Type-' + lang]}}</option>
          <option value="0">{{$store.state.option['document_Type-0-' + lang]}}</option>
          <option value="1">{{$store.state.option['document_Type-1-' + lang]}}</option>
          <option value="2">{{$store.state.option['document_Type-2-' + lang]}}</option>
        </select>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-document_Number-' + lang]}}</label>
        <input v-model="form.document_Number" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-document_Date-' + lang]}}</label>
        <!--<input v-model="form.document_Date" type="date" class="form-control">-->
        <date-picker v-model="form.document_Date" :clearable="false" :editable="false" type="date"></date-picker>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-document_Place-' + lang]}}</label>
        <input v-model="form.document_Place" type="text" class="form-control">
      </div>

      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-MobilePhone-' + lang]}}</label>
        <input v-model="form.mobile_Number" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Phone-' + lang]}}</label>
        <input v-model="form.phone_Number" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-TaxNumber-' + lang]}}</label>
        <input v-model="form.tax_Number" type="number" class="form-control">
      </div>
      <button type="button" @click="submit" class="btn btn-primary float-right">{{$store.state.option['conta_pessoal_user-UPDATE1-' + lang]}}</button>
    </div>
    <div v-else>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-clientID-' + lang]}}</label>
        <input disabled v-model="form.clientID" type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-username-' + lang]}}</label>
        <input disabled v-model="form.username" type="text" class="form-control">
      </div>

      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-name-' + lang]}}</label>
        <input v-model="form.driver_Name" disabled type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-email-' + lang]}}</label>
        <input v-model="form.email" type="email" disabled class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Address-' + lang]}}</label>
        <textarea v-model="form.address" disabled class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-PostalCode-' + lang]}}</label>
        <input v-model="form.postal_Code" disabled type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-City-' + lang]}}</label>
        <input v-model="form.city" disabled type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Country-' + lang]}}</label>
        <select id="country" class="form-control" disabled v-model="form.country" style="height:50px;">
          <option value="">{{$store.state.option['country-' + lang]}}</option>
          <option :value="'' + dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
        </select>
      </div>

      <!--<div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-MobilePhone-' + lang]}}</label>
        <input v-model="form.mobile_Number" disabled type="text" class="form-control">
      </div>-->
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Phone-' + lang]}}</label>
        <input v-model="form.Phone" disabled type="text" class="form-control">
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-Observation-' + lang]}}</label>
        <textarea v-model="form.observations" disabled class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label>{{$store.state.option['conta_pessoal_user-TaxNumber-' + lang]}}</label>
        <input v-model="form.tax_Number" disabled type="text" class="form-control">
      </div>
      <!--<button type="button" @click="submit" class="btn btn-primary float-right">{{$store.state.option['conta_pessoal_user-UPDATE1-' + lang]}}</button>-->
    </div>

    <div class="clearfix"></div>
    <div v-if="form.role == 'driver'">
      <h2 class="text-uppercase laranja" style="margin-top:30px;">{{$store.state.option['conta_pessoal_user-TitlePassword-' + lang]}}</h2>
      <hr style="margin-bottom: 30px;">
      <div>
        <div class="form-group">
          <label>{{$store.state.option['conta_pessoal_user-Password-' + lang]}}</label>
          <input v-model="senha.password" type="password" class="form-control">
        </div>
        <div class="form-group">
          <label>{{$store.state.option['conta_pessoal_user-passNova-' + lang]}}</label>
          <input v-model="senha.new_password" type="password" class="form-control">
        </div>
        <div class="form-group">
          <label>{{$store.state.option['conta_pessoal_user-passNovaRep-' + lang]}}</label>
          <input v-model="senha.new_password1" type="password" class="form-control">
        </div>
        <button type="button" @click="modSenha" class="btn btn-primary float-right">{{$store.state.option['conta_pessoal_user-ModifyPassword-' + lang]}}</button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminUser',
  data () {
    return {
      form: {},
      lang: '',
      senha: {
        new_password: '',
        new_password1: '',
        password: ''
      }
    }
  },
  mounted () {
    if (window.location.protocol !== 'https:') {
      window.location = window.location.href.replace('http:', 'https:')
    }
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.paises1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['conta_pessoal_user-titulo-' + this.lang])
        this.axios.get('/users').then((res) => {
          // res.data.created_at = new Date(res.data.created_at)
          res.data.date_of_Birth = new Date(res.data.date_of_Birth)
          res.data.license_Date = new Date(res.data.license_Date)
          res.data.document_Date = new Date(res.data.document_Date)
          this.form = res.data
          this.SET_LOAD()
        }, (er) => {
          this.SET_AVISO(er.response.data.error)
        })
      } else {
        this._.delay(this.init, 100)
      }
    },
    submit () {
      this.SET_LOAD1(true)
      this.axios.patch('/drivers', this.form).then((res) => {
        this.SET_TOAST({ msg: this.$store.state.option['conta_pessoal_user-updateusersuccess-' + this.lang] })
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    modSenha () {
      this.SET_LOAD1(true)
      if (this.senha.new_password === this.senha.new_password1 && this.senha.new_password.length) {
        this.axios.post('/users/change-password', this.senha).then((res) => {
          this.SET_TOAST({ msg: this.$store.state.option['conta_pessoal_user-passwordsuccess-' + this.lang] })
        }, (er) => {
          this.SET_AVISO(er.response.data.status || er.response.data.error)
        })
      } else {
        this.SET_AVISO(this.$store.state.option['conta_pessoal_user-passwordInvalidade-' + this.lang])
      }
    }
  }
}
</script>
